<template>
  <RouterView v-if="ready" />
  <div v-else class="loading-state">Loading…</div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router';
import { useAuth } from './composables/useAuth';

const { ready } = useAuth();
</script>
